import { render, staticRenderFns } from "./ConTacto.vue?vue&type=template&id=54d606b0&scoped=true"
import script from "./ConTacto.vue?vue&type=script&lang=js"
export * from "./ConTacto.vue?vue&type=script&lang=js"
import style0 from "./ConTacto.vue?vue&type=style&index=0&id=54d606b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d606b0",
  null
  
)

export default component.exports